import SupplierFormNew from 'components/_pages/become-a-supplier';
// if we need to roll back use the import below
// import SupplierForm from 'components/_pages/become-a-supplier/supplier-form';
import { Box, Container } from 'components/box';
import { PageProps, SellWithUsCategory } from 'types/types';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import config from '../util/load-config';
import { prepMetaTags } from '../util/seo';
import sellWithUsCategoriesQuery from 'queries/sellWithUsCategories.graphql';
import { QuerySellWithUsCategoriesOutput } from 'types/types';
import { fetchGraphQl, parseQueryAST, isAbortError } from '../util/graphql';
import QueryError from 'components/query-error';
import { logError } from '../util/error-logger';
import { cacheControl } from 'constants/cache-control';
import { logInvalidJSON } from '../util/log-invalid-json';

interface SupplierPageProps {
  categories?: SellWithUsCategory[];
}

const Body = ({ categories }: SupplierPageProps) => {
  if (!categories) {
    return (
      <Container py={[3, null, 3]}>
        <QueryError message="" />
      </Container>
    );
  }

  return (
    <Container>
      <Box maxWidth="100%" width={[null, null, '70%']} mx="auto">
        {/* <SupplierForm categories={categories} /> */}
        <SupplierFormNew />
      </Box>
    </Container>
  );
};

export async function getServerSideProps({
  res,
}: GetServerSidePropsContext): Promise<
  GetServerSidePropsResult<SupplierPageProps & PageProps>
> {
  const meta = config.seo.meta.pages['become-a-supplier'];
  const baseProps = {
    ...(meta ? { layout: { metaTags: prepMetaTags(meta) } } : {}),
  };

  try {
    const [query, operationName] = await parseQueryAST(
      sellWithUsCategoriesQuery,
      'sellWithUsCategories'
    );

    const {
      data,
      errors,
    } = await fetchGraphQl<QuerySellWithUsCategoriesOutput>({
      operationName,
      query,
      logInvalidJSON,
    });

    // only fail if there is no data
    if (
      !data ||
      !data.sellWithUsCategories ||
      data.sellWithUsCategories.length === 0
    ) {
      // we know there should technically always be categories here
      // so we can assume that this is temporary
      res.statusCode = 503;
      res.setHeader('cache-control', cacheControl.temporary);

      // log error
      if (errors && errors.length > 0) {
        const [firstError] = errors;
        logError(firstError.message, 'sellWithUsCategories.query');
      } else {
        logError(
          'No data returned for sell with us categories',
          'sellWithUsCategories.query'
        );
      }

      // return empty props so we can render a failure page
      return { props: { ...baseProps } };
    }

    return {
      props: {
        ...baseProps,
        categories: data.sellWithUsCategories,
      },
    };
  } catch (e) {
    res.statusCode = isAbortError(e) ? 503 : 500;
    res.setHeader('cache-control', cacheControl.temporary);

    logError(e, 'become-a-supplier.catch');

    // return empty props so we can render a failure page
    return { props: { ...baseProps } };
  }
}

export default Body;
